import { Tooltip } from "@mui/material";
import Bell from "assets/img/svg/navbar/bell";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import NavigationBlockWithBadge from "./NavigationBlockWithBadge";
import NavigationButton from "./NavigationButton";

interface NotificationsButtonProps {
    /** Number of unread notifications */
    unreadCount: number;
    /** Click handler to open notifications */
    onClick: () => void;
    /** Style variant */
    variant?: "default" | "book";
    /** Whether the navigation is collapsed */
    isCollapsed?: boolean;
}

/**
 * Notifications button with badge showing unread count
 * Shows only icon when collapsed
 */
const NotificationsButton = ({
    unreadCount,
    onClick,
    variant = "default",
    isCollapsed = false,
}: NotificationsButtonProps) => {
    const { t } = useTranslation();

    const buttonClassName = classNames({
        "navigation-link--collapsed": isCollapsed,
    });

    return (
        <Tooltip title={isCollapsed ? t("NavigationBar.Notifications") : ""} placement="right" arrow>
            <span>
                <NavigationButton onClick={onClick} variant={variant} className={buttonClassName}>
                    <NavigationBlockWithBadge
                        icon={<Bell />}
                        label={t("NavigationBar.Notifications")}
                        badgeCount={unreadCount}
                        badgeTooltip={t("Notifications.UnreadTooltip", { number: unreadCount })}
                        isCollapsed={isCollapsed}
                    />
                </NavigationButton>
            </span>
        </Tooltip>
    );
};

export default NotificationsButton;
